import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewStatementPage } from '../../../features/bank/new-statement-page'
import { newBankStatementSearchSchema } from '../../../features/bank/search'
import { treasuryAccountsQueryOptions } from '../../../features/finance/queries'

export const Route = createFileRoute('/_app/bank-statements/new')({
  staticData: { crumb: 'bankStatementNew' },
  validateSearch: newBankStatementSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'treasury.reconcile'),
  loader: ({ context }) => {
    // Warm the account picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(treasuryAccountsQueryOptions)
  },
  component: NewStatementPage,
})
